import { render, staticRenderFns } from "./order_confirm.vue?vue&type=template&id=487068e8&scoped=true&"
import script from "./order_confirm.vue?vue&type=script&lang=js&"
export * from "./order_confirm.vue?vue&type=script&lang=js&"
import style0 from "./order_confirm.vue?vue&type=style&index=0&id=487068e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487068e8",
  null
  
)

export default component.exports